import _defineProperty from "D:\\a\\1\\s\\fepu\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
var genVirtualStyle = function genVirtualStyle(token) {
  var componentCls = token.componentCls,
    motionDurationMid = token.motionDurationMid,
    lineWidth = token.lineWidth,
    lineType = token.lineType,
    tableBorderColor = token.tableBorderColor,
    calc = token.calc;
  var tableBorder = "".concat(unit(lineWidth), " ").concat(lineType, " ").concat(tableBorderColor);
  var rowCellCls = "".concat(componentCls, "-expanded-row-cell");
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty(_defineProperty({}, "".concat(componentCls, "-tbody-virtual"), _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-row:not(tr)"), {
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%'
  }), "".concat(componentCls, "-cell"), {
    borderBottom: tableBorder,
    transition: "background ".concat(motionDurationMid)
  }), "".concat(componentCls, "-expanded-row"), _defineProperty({}, "".concat(rowCellCls).concat(rowCellCls, "-fixed"), {
    position: 'sticky',
    insetInlineStart: 0,
    overflow: 'hidden',
    width: "calc(var(--virtual-width) - ".concat(unit(lineWidth), ")"),
    borderInlineEnd: 'none'
  }))), "".concat(componentCls, "-bordered"), _defineProperty(_defineProperty({}, "".concat(componentCls, "-tbody-virtual"), _defineProperty({
    '&:after': {
      content: '""',
      insetInline: 0,
      bottom: 0,
      borderBottom: tableBorder,
      position: 'absolute'
    }
  }, "".concat(componentCls, "-cell"), _defineProperty({
    borderInlineEnd: tableBorder
  }, "&".concat(componentCls, "-cell-fix-right-first:before"), {
    content: '""',
    position: 'absolute',
    insetBlock: 0,
    insetInlineStart: calc(lineWidth).mul(-1).equal(),
    borderInlineStart: tableBorder
  }))), "&".concat(componentCls, "-virtual"), _defineProperty({}, "".concat(componentCls, "-placeholder ").concat(componentCls, "-cell"), {
    borderInlineEnd: tableBorder,
    borderBottom: tableBorder
  }))));
};
export default genVirtualStyle;